const last = (xs) => xs[xs.length - 1];
import 'data/array';
import * as angular from 'angular';
import { ConfirmationModal } from 'modules/ui';
import BulkInsertView from './modal/BulkInsertView.html';
import { BulkInsertController } from './modal/BulkInsertController';
export class FaqEditQuestionController {
    constructor($state, $stateParams, $scope, ngToast, HostingService, LoadingService, FaqService, ModalService, PermissionsService, application, $timeout, $translate) {
        'ngInject';
        this.HostingService = HostingService;
        this._$state = $state;
        this._$scope = $scope;
        this._ngToast = ngToast;
        this._loadingService = LoadingService;
        this._faqService = FaqService;
        this._modalService = ModalService;
        this._permissionsService = PermissionsService;
        this._application = application;
        this._$timeout = $timeout;
        this._$translate = $translate;
        // view model
        this._selectedSet = undefined;
        this.questions = []; // : {Array<string>
        this.answer = '';
        //Questions
        const referenceName = $stateParams.id;
        if (referenceName) {
            this._loadQuestions(referenceName);
        }
        //Event Listeners
        this.initEventListeners();
    }
    get selectedSet() {
        return this._selectedSet;
    }
    async bulkInsert() {
        const modalSettings = {
            template: BulkInsertView,
            controller: BulkInsertController,
            controllerAs: '$ctrl',
            inputs: {
                questions: this.questions,
            },
        };
        const modal = await this._modalService.showModal(modalSettings);
        const modalData = await modal.close;
        this.questions = modalData;
    }
    async initEventListeners() {
        this._$scope.$on('RepeatedItem', async (e) => {
            //Error: This question has been already inserted before
            this.questionsForm.$invalid = true;
            e.stopPropagation();
        });
        this._$scope.$on('SuccessfullyInsert', () => (this.questionsForm.$invalid = false));
        this._hasPermission = await this._permissionsService.hasPermissions('write');
    }
    saveSet() {
        this._$timeout(() => {
            this.save();
        });
    }
    hasItemInList(list, item) {
        return (list.filter((x) => x.value.toLowerCase() == item.toLowerCase())
            .length > 0);
    }
    //
    async save() {
        if (!this._hasPermission) {
            const errorMsg74 = await this._$translate('utils.errorMsg.74');
            this._ngToast.danger(errorMsg74);
            return;
        }
        this._$scope.$broadcast('Save');
        if (this.questionsForm.$invalid) {
            return;
        }
        if (this.faqForm.$valid && this.questionsForm.$valid) {
            this._loadingService.startLoading();
            try {
                //parallels promises
                await Promise.all([this._publish(), this._createOrUpdateSet()]);
                const successMsg8 = await this._$translate('utils.successMsg.8');
                this._ngToast.success(successMsg8);
                this._$state.go('auth.application.detail.faq.index', {
                    shortName: this._application.shortName,
                });
            }
            finally {
                this._loadingService.stopLoading();
            }
        }
        else {
            const errorMsg61 = await this._$translate('utils.errorMsg.61');
            this._ngToast.danger(errorMsg61);
        }
    }
    //
    sliceText(text, size) {
        return text.length > size ? `${text.slice(0, size)}` : text;
    }
    //
    async _loadQuestions(referenceName) {
        this._loadingService.startLoading();
        try {
            //Get complete set with questions
            const selectedSet = await this._faqService.getIntentionByReferenceName(referenceName);
            const { items } = await this._faqService.getQuestions(selectedSet.id);
            this._selectedSet = selectedSet;
            this.answer = this._selectedSet.body;
            this.questions = items.map((item) => item.text);
            //Questions copy. In case of edit set, old questions must keeps intact.
            this.questionsCopy = angular.copy(this.questions);
        }
        catch (e) {
            const errorMsg15 = await this._$translate('utils.errorMsg.15');
            this._ngToast.danger(errorMsg15);
            throw e;
        }
        finally {
            this._loadingService.stopLoading();
        }
    }
    /**
     * Registers a new intention/set if one wasn't supplied.
     * If it already exists, delete and then recreate as so to update it.
     */
    async _createOrUpdateSet() {
        try {
            if (this._selectedSet && this._selectedSet.id) {
                await this._faqService.deleteIntention(this._selectedSet.id, this._selectedSet.referenceName);
            }
            // The set name is always the name of the first question added (last question in the array).
            // The reference name is the set name without spaces.
            const name = this.sliceText(last(this.questions), 127);
            const timestamp = new Date().getTime();
            let referenceName = name.replace(/\s+/g, '');
            referenceName = `${timestamp}${referenceName.replace(/\W/g, '')}`;
            await this._faqService.registerIntention({
                ...this._selectedSet,
                name,
                referenceName: !this._selectedSet
                    ? referenceName
                    : this._selectedSet.referenceName,
                questions: this.questions.map((text) => ({ text })),
                body: this.answer,
            });
        }
        catch (e) {
            //Same question in other set
            if (e.description.indexOf('The entity already exists') != -1) {
                //Error: Question already exists in the knowledge base
                const existingQuestion = await this._$translate('modules.application.detail.templates.faq.existingQuestion');
                this._ngToast.danger(existingQuestion);
                //Re-insert old set with old questions
                if (this.questionsCopy) {
                    await this._faqService.registerIntention({
                        ...this._selectedSet,
                        questions: this.questionsCopy.map((text) => ({
                            text,
                        })),
                        body: this.answer,
                    });
                    this._selectedSet = await this._faqService.getIntentionByReferenceName(this._selectedSet.referenceName);
                }
                throw e;
            }
            //Error: An error occurs on update knowledge base
            const errorUpdateBase = await this._$translate('modules.application.detail.templates.faq.errorUpdateBase');
            this._ngToast.danger(errorUpdateBase);
            throw e;
        }
    }
    async _publish() {
        try {
            await this.HostingService.publish(this._application, this._application.template, this._application.applicationJson);
        }
        catch (e) {
            //Error: An error occurred while posting chatbot
            const errorMsg14 = await this._$translate('utils.errorMsg.14');
            this._ngToast.danger(errorMsg14);
            throw e;
        }
    }
    async removeSet() {
        this._loadingService.startLoading();
        try {
            await this._faqService.deleteIntention(this._selectedSet.id, this._selectedSet.referenceName);
            //Success: Question deleted
            const successMsg11 = await this._$translate('utils.successMsg.11');
            this._ngToast.success(successMsg11);
            this._$state.go('auth.application.detail.faq.index', {
                shortName: this._application.shortName,
            });
        }
        catch (e) {
            //Error: An error occurred while deleting an item from the knowledge base
            const errorMsg17 = await this._$translate('utils.errorMsg.17');
            this._ngToast.danger(errorMsg17);
            throw e;
        }
        finally {
            this._loadingService.stopLoading();
        }
    }
    async confirmDelete() {
        if (!this._hasPermission) {
            const errorMsg74 = await this._$translate('utils.errorMsg.74');
            this._ngToast.danger(errorMsg74);
            return;
        }
        const modalTitle = await this._$translate('modules.application.detail.templates.faq.modalTitle');
        const modalBody = await this._$translate('modules.application.detail.templates.faq.modalBody');
        const yes = await this._$translate('utils.misc.yes');
        const no = await this._$translate('utils.misc.no');
        const modal = await this._modalService.showModal(ConfirmationModal({
            title: {
                text: modalTitle,
            },
            body: modalBody,
            buttons: {
                confirm: {
                    text: yes,
                },
                cancel: {
                    text: no,
                },
            },
        }));
        const confirmation = await modal.close;
        if (confirmation) {
            this.removeSet();
        }
    }
}
// Explicit AngularJS DI annotation for minification safety
FaqEditQuestionController.$inject = ['$state', '$stateParams', '$scope', 'ngToast', 'HostingService', 'LoadingService', 'FaqService', 'ModalService', 'PermissionsService', 'application', '$timeout', '$translate'];
